export default {
  'pages.layouts.userLayout.title': '你好！',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.workbench.link': '工作台',
  'pages.workbench.alertMessage': '欢迎来到工作台',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',
  'pages.template.title': '企业知识图谱',
  'pages.template.submit.success': '表单提交成功！',
  'pages.template.form.name': '姓名',
  'pages.template.form.email': '邮箱',
  'pages.template.form.department': '部门',
  'pages.template.form.joinDate': '入职日期',
  'pages.template.form.remarks': '备注',
  'pages.template.placeholder.name': '请输入姓名',
  'pages.template.placeholder.email': '请输入邮箱',
  'pages.template.placeholder.department': '请选择部门',
  'pages.template.placeholder.remarks': '请输入备注信息',
  'pages.template.validation.nameRequired': '请输入姓名',
  'pages.template.validation.emailRequired': '请输入邮箱',
  'pages.template.validation.emailInvalid': '邮箱格式不正确',
  'pages.template.validation.departmentRequired': '请选择部门',
  'pages.template.validation.joinDateRequired': '请选择入职日期',
  'pages.template.department.tech': '技术部',
  'pages.template.department.sales': '销售部',
  'pages.template.department.hr': '人力资源部',
  'pages.template.department.finance': '财务部',
  'pages.template.action.submit': '提交',
  'pages.template.action.reset': '重置',
};
